import { render, staticRenderFns } from "./showConvocationFormEdition.vue?vue&type=template&id=4eb2116d"
import script from "./showConvocationFormEdition.vue?vue&type=script&lang=js"
export * from "./showConvocationFormEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports